import React, { FC } from 'react';
import { TypeMediaTextTitleFields } from '@/core/generated-types';
import { CONTENT_TYPE_MEDIA_TEXT_TITLE } from '@/core/constants';
import { ProductBlock, ValueProposition } from '@/components';

const MediaTextTitle: FC<TypeMediaTextTitleFields> = (fields) => {
  const { layoutType } = fields;

  switch (layoutType) {
    // large and medium cases both share <ProductBlock />
    case CONTENT_TYPE_MEDIA_TEXT_TITLE.LARGE:
    case CONTENT_TYPE_MEDIA_TEXT_TITLE.MEDIUM:
    case CONTENT_TYPE_MEDIA_TEXT_TITLE.SMALL:
      return <ProductBlock {...fields} />;
    case CONTENT_TYPE_MEDIA_TEXT_TITLE.VALUE_PROP:
      return <ValueProposition {...fields} />;
    default:
      console.warn('MediaTextTitle -> no matching layoutType');
      return null;
  }
};

export default React.memo(MediaTextTitle);
